
import React from "react";
import styles from "../../Borrower/BorrowerDetails/BorrowerDetails.module.css";
import CloseIcon from "@mui/icons-material/Close";

const CoApplicantModal = ({ coapplicantData, closeModalDetails, modalData }) => {
    console.log(coapplicantData)
    console.log(modalData)
    return (
        <div className="coapplicantDetailsModal">
            <div
                className="coapplicantDetailsModaOverlay"
                onClick={(e) => e.target === e.currentTarget && closeModalDetails}
            >
                <div className="coapplicantDetailsModalContent">
                    <h3>{modalData}</h3>
                    {coapplicantData
                        .filter(item => item.section === modalData)
                        .map((item, index) => (
                            <div key={index}>
                                <p>{item.label}</p>
                                <p>{item.Value}</p>
                            </div>
                        ))}
                    <CloseIcon
                        className={styles.CloseIcon}
                        onClick={closeModalDetails}
                    />
                </div>
            </div>
        </div>
    );
};

export default CoApplicantModal;
